import styled from '../../../theme/styled-with-theme';
import { mediaQueries } from '../../../styles/media-queries';
import { pxToRem } from '../../../styles/utils';

import { Flexbox } from '../../Flexbox';

export const Table = styled(Flexbox)`
  flex-direction: column;
  width: 100%;
  border: ${pxToRem(1.5)} solid #f1f1f1;

  &:not(:nth-last-of-type(1)) {
    border-bottom: 0;
  }

  &:nth-of-type(1) {
    .sft-cell {
      text-align: center;

      p {
        margin: 0;

        &:nth-of-type(1) {
          font-size: ${({ theme }) => theme.fontSize['2xs']};
          font-weight: 600;
        }

        &:nth-of-type(2) {
          font-size: ${({ theme }) => theme.fontSize.m};

          a {
            text-decoration: none;
          }

          span {
            font-weight: 500 !important;
          }
        }
      }
    }
  }

  &:nth-of-type(3) {
    .sft-cell {
      flex: 1;
      text-align: center;

      p:nth-of-type(1n + 1) {
        margin: 0;
      }
    }
  }

  &:nth-of-type(4) {
    .sft-cell {
      p {
        a {
          text-decoration: none;
        }
      }
    }
  }

  ${mediaQueries.desktop} {
    &:nth-of-type(1) {
      .sft-cell {
        p {
          &:nth-of-type(1) {
            font-size: ${pxToRem(21)};
          }

          &:nth-of-type(2) {
            font-size: ${({ theme }) => theme.fontSize['4xl']};
          }
        }
      }
    }
  }
`;

export const TableRow = styled(Flexbox)`
  justify-content: space-between;
  padding: ${pxToRem(25)};

  border-bottom: ${pxToRem(1.5)} solid #f1f1f1;

  &:nth-last-of-type(1) {
    border-bottom: 0;
  }
`;

export const Paragraph = styled('p')`
  margin-bottom: ${pxToRem(16)};
  font-size: ${({ theme }) => theme.fontSize.s};
  font-weight: normal;
  font-weight: 300;

  span:not(.footnote) {
    font-weight: 600;
  }

  a {
    color: ${({ theme }) => theme.color.inlineAnchor};

    span:not(.footnote) {
      font-weight: 600;
    }
  }

  ${mediaQueries.desktop} {
    font-size: ${({ theme }) => theme.fontSize.m};
  }
`;
